import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "titleField"];

  handleKeydown(event) {
    // Handle Enter key - apply changes
    if (event.key === "Enter") {
      event.preventDefault();

      // Explicitly blur the input to avoid keeping focus
      this.inputTarget.blur();
    }
  }

  updateHiddenField(event) {
    // Update the hidden title field as the user types
    if (this.hasTitleFieldTarget) {
      this.titleFieldTarget.value = event.target.value.trim();
    }
  }
}
